import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { GroupDto } from 'src/app/interfaces/groupDto';
import { Groups } from 'src/app/interfaces/groups';
import { ImportFileCsv } from 'src/app/interfaces/importFileCsv';

import { MatButton } from '@angular/material/button';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { ImportFileXlsxComponent } from '../../import-file-xlsx/import-file-xlsx.component';
import { ImportFileComponent } from '../../import-file/import-file.component';
import { TableVisualizationComponent } from '../../table-visualization/table-visualization.component';
import { GroupElementService } from './group-element.service';

@Component({
  selector: 'mic-app-group-element',
  templateUrl: './group-element.component.html',
  styleUrls: ['./group-element.component.scss'],
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    ImportFileComponent,
    TableVisualizationComponent,
    ImportFileXlsxComponent,
    MatButton,
    MatIcon
  ]
})
export class GroupElementComponent implements OnInit {
  private readonly groupService = inject(GroupElementService);
  private readonly cdr = inject(ChangeDetectorRef);

  user = JSON.parse(localStorage.getItem('user'));
  importFileCsv: ImportFileCsv;
  @Input() element: Groups;
  @Output() deleteItemEvent = new EventEmitter<number>();
  group: GroupDto;
  panelOpenState = false;
  ngOnInit(): void {
    this.groupService.getGroupById(this.element.id).subscribe((response) => {
      this.group = response;
      this.cdr.detectChanges();
    });
  }

  onDelete(): void {
    this.groupService.deleteGroupById(this.element.id).subscribe(() => {
      this.deleteItemEvent.emit(this.element.id);
      this.cdr.detectChanges();
    });
  }
}
